// @ts-nocheck
document.addEventListener('DOMContentLoaded', function() {
  if (typeof tns === 'undefined') return;
  
  const awardBadges = document.querySelectorAll('.award-badges');
  
  awardBadges.forEach(function(section) {
    const mobilePadding = section.getAttribute('data-mobile-padding');
    const itemCount = parseInt(section.getAttribute('data-item-count'));
    
    if (mobilePadding) {
      section.style.setProperty('--mobile-padding', mobilePadding + 'px');
    }
    
    // Only initialize slider for 3+ items
    if (itemCount >= 3) {
      const slider = section.querySelector('.award-badges__slider');
      if (slider) {
        initializeAwardBadgesSlider(slider, itemCount);
      }
    }
  });
});

function initializeAwardBadgesSlider(slider, itemCount) {
  // Only initialize if we have 3+ items
  if (itemCount < 3) {
    return;
  }
  
  const windowWidth = window.innerWidth;
  
  // For exactly 3 items, only show slider on mobile (600px and below)
  if (itemCount === 3 && windowWidth > 600) {
    return;
  }
  
  let awardSlider = null;
  let intersectionObserver = null;
  let resizeRequestId = null;
  const section = slider.closest('.award-badges');
  
  function initAwardSlider() {
    // Destroy existing slider if it exists
    if (awardSlider) {
      awardSlider.destroy();
      awardSlider = null;
    }
    
    // Re-check item count and window width
    const currentItemCount = parseInt(section?.getAttribute('data-item-count') || itemCount);
    const currentWidth = window.innerWidth;
    
    // For exactly 3 items, only show slider on mobile (600px and below)
    if (currentItemCount === 3 && currentWidth > 600) {
      return;
    }
    
    const sliderConfig = {
      container: slider,
      loop: true,
      gutter: 20,
      // Base config for mobile (< 480px): 1 slide with center
      items: 1,
      center: true,
      edgePadding: 110, // Equivalent to centerPadding: '110px' in Tiny Slider
      controls: false,
      nav: false,
      mouseDrag: true,
      touch: true,
      speed: 500,
      slideBy: 1,
      responsive: {
        // Tiny Slider uses min-width breakpoints (mobile-first)
        // Tiny Slider breakpoints (max-width): 1200 = 4 slides, 990 = 3 slides, 768 = 2 slides, 480 = 1 slide
        // Tiny Slider (min-width): < 480 = 1 slide (base), 481-768 = 2 slides, 769-990 = 3 slides, 991+ = 4 slides
        481: {
          items: 2,
          center: true,
          edgePadding: 80, // Equivalent to centerPadding: '80px' in Tiny Slider
          loop: true,
          slideBy: 1,
        },
        767: {
          items: 3,
          center: false,
          edgePadding: 0,
          loop: true,
          slideBy: 1,
        },
        1024: {
          items: 4,
          center: false,
          edgePadding: 0,
          loop: true,
          slideBy: 1,
        },
        // 1200+ keeps 4 items (from 991 breakpoint)
      },
    };
    
    try {
      awardSlider = tns(sliderConfig);
    } catch (error) {
      // Error initializing slider
    }
  }
  
  // Use IntersectionObserver to initialize slider when it enters viewport
  if (section && 'IntersectionObserver' in window) {
    intersectionObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Section is in viewport, initialize slider
          const currentItemCount = parseInt(section.getAttribute('data-item-count') || itemCount);
          const currentWidth = window.innerWidth;
          
          // For exactly 3 items, only show slider on mobile (600px and below)
          if (currentItemCount === 3 && currentWidth > 600) {
            return;
          }
          
          if (!awardSlider && currentItemCount >= 3) {
            initAwardSlider();
          }
          
          // Disconnect observer after first initialization
          if (intersectionObserver) {
            intersectionObserver.disconnect();
            intersectionObserver = null;
          }
        }
      });
    }, {
      rootMargin: '50px' // Start loading slightly before element enters viewport
    });
    
    intersectionObserver.observe(section);
  } else {
    // Fallback: initialize immediately if IntersectionObserver not supported
    initAwardSlider();
  }
  
  // Reinitialize on window resize using requestAnimationFrame
  function handleResize() {
    if (resizeRequestId) {
      cancelAnimationFrame(resizeRequestId);
    }
    
    resizeRequestId = requestAnimationFrame(function() {
      const currentItemCount = parseInt(section?.getAttribute('data-item-count') || itemCount);
      const currentWidth = window.innerWidth;
      
      // For exactly 3 items, only show slider on mobile (600px and below)
      if (currentItemCount === 3 && currentWidth > 600) {
        if (awardSlider) {
          awardSlider.destroy();
          awardSlider = null;
        }
        return;
      }
      
      // Rebuild slider if it doesn't exist and we have 3+ items
      if (!awardSlider && currentItemCount >= 3) {
        initAwardSlider();
      } else if (awardSlider) {
        // Rebuild to apply new responsive settings
        initAwardSlider();
      }
    });
  }
  
  window.addEventListener('resize', handleResize);
}

